import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Contract } from "@edp-components/edp-contract";
import { EdpModalService } from "@edp-components/edp-modal";
import { ExternalLinkService } from "@edp-directives/external-link/external-link.service";
import { SelfcareEnum } from "@edp-enums/selfcare.enum";
import { ServiceFunctionalityEnum, ServiceTypeEnum } from "@edp-enums/service-type.enum";
import { Service } from "@edp-models/service.model";
import { NewRequestService } from "@edp-pages/requests-and-operations/services/new-request.service";
import { ContractService } from "@edp-services/contract.service";
import { DatalayerService } from "@edp-services/datalayer.service";
import { GetBenefitsUsersDetails } from "@edp-store/actions/benefits.actions";
import { GetContracts, ShowContractSelection } from "@edp-store/actions/contract.actions";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getUser } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { take } from "rxjs/operators";

@Component({
    selector: "create-request-faq-selfcare",
    templateUrl: "./create-request-faq-selfcare.component.html",
    styleUrls: ["./create-request-faq-selfcare.component.scss"]
})

export class CreateRequestFaqSelfcare implements OnInit, OnChanges {
    @Input() motive: Service;

    @ViewChild("slickModal") slickModal: SlickCarouselComponent;

    public contract: Contract;
    public selfcareEnum = SelfcareEnum;
    public isSelfcare = false;
    public link: string;
    public slideConfig: object = {};
    public slidesToShow = 3;
    public slidesToScroll = 3;
    public firebaseId: string;
    public labelReturnAction: string = null;

    constructor(
        private store: Store<IAppState>,
        private newRequestService: NewRequestService,
        private externalLinkService: ExternalLinkService,
        private router: Router,
        private edpModalService: EdpModalService,
        private contractService: ContractService,
        private datalayerService: DatalayerService,
    ) {
        this.store.pipe(select(getUser)).subscribe(user => {
            if (user) {
                this.firebaseId = user.uid;
            }
        });
    }

    public ngOnInit() {
        this.store.pipe(
            select(getContract),
            take(1)
        ).subscribe(contract => {
            if (contract) {
                this.contract = contract;
                this.newRequestService.selectContract(contract);
            } else {
                this.store.dispatch(new ShowContractSelection());
            }
        });

        this.slideConfig = {
            slidesToShow: this.slidesToShow,
            slidesToScroll: this.slidesToScroll,
            infinite: false,
            arrows: false,
            variableWidth: true,
            focusOnSelect: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1.3,
                        slidesToScroll: 1,
                        focusOnSelect: false,
                    },
                },
            ],
        };
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.isSelfcare = this.showSelfcare();
        this.labelReturnAction = null;
    }

    public syncWallet(): void {
        this.store.dispatch(new ShowLoader(true));
        this.contractService.syncWallet(this.firebaseId).subscribe(
            () => {
                this.labelReturnAction = "pt.edp.edponline.requests-and-operations.sync.wallet.return";
                this.store.dispatch(new ShowLoader(false));
                this.store.dispatch(new GetContracts(true));
                this.store.dispatch(new GetBenefitsUsersDetails());
            },
            () => this.store.dispatch(new ShowLoader(false))
        );
    }

    public getFormattedName(title) {
        return title.toLowerCase().replace(" ", "-");
    }

    private datalayerAction(): void {
        this.datalayerService.setGaClick("clickOpenLink", {
            formModal: this.link,
            interactionName: this.getFormattedName(this.motive.name),
            interactionLocation: "criar-pedido-modal"
        });
    }

    public motiveAction(): boolean {
        let closeModal = true;
        if (!!this.motive.typeRoute && this.motive.typeRoute === ServiceTypeEnum.FUNCTIONALITY) {
            if (this.motive.route === ServiceFunctionalityEnum.SYNC_WALLET) {
                closeModal = false;
                this.syncWallet();
            }
            return closeModal;
        }
        if (this.motive.selfcare === this.selfcareEnum.EDPPT) {
            this.link = this.motive.actionLink;

            this.datalayerAction();

            this.externalLinkService.externalLink(this.link);
            return closeModal;
        }
        if (this.motive.selfcare === this.selfcareEnum.EDPONLINE) {
            this.link = this.motive.route;
            const params: string[] = this.motive.route.match(/:\w*/g);

            params.forEach(param => {
                switch (param.substr(1).toLowerCase()) {
                    case "contractid":
                        this.link = this.link.replace(param, this.contract.ContractId);
                        break;
                }
            });

            this.datalayerAction();

            this.router.navigate([this.link]);
            return closeModal;
        }
    }

    public getLink() {
        const closeModal = this.motive ? this.motiveAction() : true;

        if (closeModal) {
            this.newRequestService.resetData();
            this.edpModalService.close(false);
        }
    }

    public showSelfcare(): boolean {
        return this.motive && !!this.motive.action;
    }
}
